import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LayoutSidebarState {
    isCollapsed: boolean;
}

const initialState: LayoutSidebarState = {
    isCollapsed: false,
};

const layoutSidebarSlice = createSlice({
    name: "layoutSidebar",
    initialState,
    reducers: {
        setCollapsed: (state, action: PayloadAction<boolean>) => {
            state.isCollapsed = action.payload;
        },
        toggleCollapsed: (state) => {
            state.isCollapsed = !state.isCollapsed;
        },
    },
});

export const { setCollapsed, toggleCollapsed } = layoutSidebarSlice.actions;
export const layoutSidebarReducer = layoutSidebarSlice.reducer;
